/** @format */

import { Modal, Button, Spin, Typography } from "antd";
import { isUndefined } from "lodash";
import { React, useEffect, useState } from "react";
import { useQuery } from "react-query";
import "react-toastify/dist/ReactToastify.css";
import "rsuite/dist/rsuite.min.css";
import axios from "../lib/axios";
import { authMethod } from "../lib/set_payment_header";
import { useGeneralState } from "../state/useGeneralState";
import { toast } from "react-toastify";
import CryptoJS from "crypto-js";
import RedirectDialog from "./dialog/RedirectDialog";
import { useDispatch } from 'react-redux';
import { setPaidAmount, setPaymentComment } from '../state/paymentSlice.js';
import ItemAmount from "./ItemAmount.jsx";

const { Text } = Typography;

function HandleAmount({
    publicKey,
    isGuest,
    tempAmount,
    setPropsAmount,
    productId,
    amount,
    currency,
    merchant,
    setIsProduct,
    propsProduct,
    propsProductIds,
    merchantDetails,
    setPropsProducts,
    setSelectedProduct,
    setOnce,
    isProduct,
    once,
    isGiftAid,
    setIsGiftAid,
    setPropProductList,
    shouldModifyAmount,
    customerName,
    customerEmail,
    onTotalAmountChange
}) {
    const { transactionBaseUrl, xcelPaymentUrl } = useGeneralState();
    const [showMessage, setShowMessage] = useState(false);
    const [showSystemMessage, setShowSystemMessage] = useState(false);
    const [showUkMaxAmountMessage, setUkMaxAmountMessage] = useState(false);
    const [isApplePay, setApplePay] = useState(false);
    const [agreementResponse, setAgreementResponse] = useState();
    const [redirectUrl, setRedirectUrl] = useState('');
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [paidAmounts, setPaidAmounts] = useState({});
    const [paymentComments, setPaymentComments] = useState({});
    const productsDetails = {};
    const dispatch = useDispatch();

    const ukMaxAmountMessage = (
        <Modal
            okType="primary"
            title="Maximum Amount Reached"
            open={showUkMaxAmountMessage}
            onCancel={() => 
                setUkMaxAmountMessage(false)
            }
            footer={[
                <Button
                    key="ok"
                    type="primary"
                    style={{ color: "#fff", backgroundColor: "#222121" }}
                    onClick={() => {
                        setUkMaxAmountMessage(false);
                    }}
                >
                    OK
                </Button>,
            ]}
        >
            <p className="text-left">
                If you need to give above <strong>£8000.00</strong>, 
                kindly call <strong>01322292097</strong> and ask for the Finance Office.
            </p>
            <hr />
        </Modal>
    );

    const message = (
        <Modal
            okType="primary"
            title={`${"Gift Aid"}`}
            visible={showMessage}
            onCancel={() => {
                setShowMessage(false);
                setIsGiftAid(false);
            }}
            footer={null}
            // cancelText="No"
            okText="Yes"
            okButtonProps={{ color: "#1890ff" }}
            // onOk={() => {
            //     setShowMessage(false);
            //     setIsGiftAid(true);
            //     setShowSystemMessage(true);
            // }}
        >
            <p>
                I want to Gift Aid donations on this form to this organisation.
                I am a UK taxpayer and understand that if I pay less income tax
                and / or capital gains tax than the amount of Gift Aid claimed
                on all my donations in that tax year, it is my responsibility to
                pay any difference.
            </p>
            <hr />
            <div className="flex items-center font-medium">
                <input
                    type="radio"
                    name="description"
                    value={"Yes"}
                    onChange={(e) => {
                        setAgreementResponse(e);
                        setIsGiftAid(true);
                    }}
                />
                &nbsp; Yes &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                <input
                    type="radio"
                    name="description"
                    value={"No"}
                    onChange={(e) => {
                        setAgreementResponse(e);
                        setIsGiftAid(false);
                    }}
                />
                &nbsp; No &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                {merchantDetails?.ent_type === "RELIGIOUS" && (
                    <>
                        <input
                            type="radio"
                            name="description"
                            value={"No"}
                            onChange={(e) => {
                                setAgreementResponse(e);
                                setIsGiftAid(false);
                            }}
                        />
                        &nbsp; Corporate
                    </>
                )}
            </div>

            <button
                className="bg-[#222121] text-white 
				w-full p-3 text-center rounded-md mt-7 
				cursor-pointer hover:bg-[#323131]"
                onClick={() => {
                    setShowMessage(false);
                    setShowSystemMessage(true);
                }}
                disabled={agreementResponse == null ? true : false}>
                Proceed
            </button>
        </Modal>
    );

    const runApplePay = async () => {
        try {
            const reference = (Math.floor(Math.random() * 10000000000)).toString();
            // Build products payload from current selection to mirror StripeForm behavior
            const keys = {};
            const comments = {};

            if (Array.isArray(selectedProducts) && selectedProducts.length > 0) {
                selectedProducts.forEach((productId) => {
                    const product = propsProduct?.[productId];
                    const amt = Number(product?.amount ?? 0);
                    if (amt && amt !== 0) {
                        keys[productId] = amt;
                        comments[productId] = product?.comment || "";
                    }
                });
            } else if (propsProduct && typeof propsProduct === 'object') {
                // Fallback: include any with positive amount
                Object.entries(propsProduct).forEach(([productId, value]) => {
                    const amt = Number(value?.amount ?? 0);
                    if (amt && amt !== 0) {
                        keys[productId] = amt;
                        comments[productId] = value?.comment || "";
                    }
                });
            }
            const result = await axios.post(
                `${transactionBaseUrl}stripe/payment-intent?amount=${amount.toFixed(3)}&currency=${merchantDetails?.currency.currency_code}`,
                {
                    merchant_id: merchantDetails.merchant_id,
                    stripeId: merchantDetails.stripe_id,
                    reference: reference,
                    customerName: customerName,
                    customerEmail: customerEmail,
                    isGiftAid: isGiftAid,
                    paymentType: 'card',
                    alpha2CountryCode: merchantDetails?.currency.iso_code_2,
                    description: JSON.stringify(keys),
                    comments
                }
            );
    
            const clientSecret = result.data.client_secret;
            if (!clientSecret) {
                console.log('Client secret not found!');
                return;
            }
    
            if (result.data?.error?.message) {
                console.log(result.data.error.message);
                return;
            }
    
            const secretKey = "etranzactglobalresourceapplepay";
            const data = {
                amount: amount,
                client_secret: clientSecret,
                alpha2CountryCode: merchantDetails?.currency.iso_code_2,
                currency: merchantDetails?.currency.currency_code.toLowerCase(),
                merchant: merchantDetails,
                customerName: customerName,
                reference: reference
            };
    
            const stringifiedData = JSON.stringify(data);
            const encrypted = CryptoJS.AES.encrypt(stringifiedData, secretKey).toString();
            const encodedEncryptedData = encodeURIComponent(encrypted);

            // DEV REDIRECT
            // setRedirectUrl(`https://improved-bold-anteater.ngrok-free.app?data=${encodedEncryptedData}`);
            //setRedirectUrl(`https://frabjous-twilight-09470d.netlify.app?data=${encodedEncryptedData}`);
            setRedirectUrl(`https://pay.xcelapp.com?data=${encodedEncryptedData}`);

            // PROD REDERECT
            //  setRedirectUrl(`https://pay.xcelapp.com?data=${encodedEncryptedData}`);
            (document.getElementById('redirect-modal')).click();
        } catch (error) {
            console.error('Error occurred during payment process:', error);
        }
    }

    const systemMessage = (
        <Modal
            okType="primary"
            title={`Confirm Payment`}
            visible={showSystemMessage}
            onCancel={() => {
                setShowSystemMessage(false);
            }}
            okButtonProps={{ color: "#fff", backgroundColor: "#222121" }}
            defaultBg="#222121"
            cancelText="No"
            okText="Yes"
            onOk={() => {
                if(isApplePay) {
                    setShowSystemMessage(false);
                    runApplePay();
                } else {
                    setShowSystemMessage(false);
                    setIsProduct();
                }
            }}>
            <p className="text-left">
                Are you sure you want to make a <br />
                one time {isGiftAid ? "gift" : "payment"} of{" "}
                <span className="font-bold">
                    {currency?.symbol}
                    {Number(amount ?? 0).toFixed(2)}
                </span>{" "}
                to{" "}
                <span className="font-bold">
                    {merchantDetails?.reg_name ?? ""}
                </span>
            </p>
            <hr />
        </Modal>
    );

    const { data: merchantProduct } = useQuery(
        ["product-xcel", merchant?.merchant_id],
        async () => {
            return axios.get(
                `${xcelPaymentUrl}merchants/giving/products/${
                    merchant?.merchant_id ?? ""
                }`,
                {
                    headers: {
                        ...(await authMethod({})),
                    },
                }
            );
        }
    );

    const prophetProduct = merchantProduct?.data?.data?.data?.filter((product) =>
        product?.name?.toLowerCase()?.includes("prophet")
    );

    const hasProphetProduct = merchantProduct?.data?.data?.data?.some(
        (product) => product?.name?.toLowerCase()?.includes("prophet")
    );


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const productList = merchantProduct?.data?.data?.data ?? [];

    const updateTotalAmount = () => {
        const newTotalAmount = Object.values(propsProduct)
            .reduce((acc, prod) => acc + (Number(prod.amount || 0)), 0); // Sum all product amounts
        
        setPropsAmount(newTotalAmount);
        onTotalAmountChange(newTotalAmount);
    };

    useEffect(() => {
        updateTotalAmount();
    }, []);
    // propsProduct

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const setGeneralAmount = (amount, id) => {
        let tempvalue = propsProduct[id];
        tempvalue.amount = amount;
        const prodValue = {
            ...propsProduct,
            [`${id}`]: tempvalue,
        };

        const numericAmount = Number(amount) || 0;

        setPaidAmounts(prevState => ({
            ...prevState,
            [id]: parseInt(numericAmount.toFixed(2)),
        }));

        updateTotalAmount();

        if (amount > 0) {
            const isAlreadySelected = selectedProducts.includes(id);
            if (!isAlreadySelected) {
                setSelectedProducts([...selectedProducts, id]);
            }
        }

        const newProductAmount = selectedProducts.reduce((acc, cur) => {
            return Number(acc) + Number(prodValue[cur]?.amount);
        }, 0);

        setPropsProducts({ ...prodValue });

        setPropsAmount(Number(newProductAmount));

        if(productId && newProductAmount !== 0 && publicKey) {
            setIsGiftAid(false);
            setIsProduct();
        }
    };

    const handleCheckboxChange = (id, amount) => {
        setSelectedProducts((prevSelectedProducts) => {
            const isAlreadySelected = prevSelectedProducts.includes(id);
            const updatedProducts = isAlreadySelected
                ? prevSelectedProducts.filter((productId) => productId !== id)
                : [...prevSelectedProducts, id];

            // Recalculate the new total
            const newProductAmount = updatedProducts.reduce((acc, cur) => {
                return Number(acc) + Number(propsProduct[cur]?.amount);
            }, 0);

            dispatch(setPaidAmount({ id, amount }));

            setPropsAmount(Number(newProductAmount));

            return updatedProducts;
        });
    };

    useEffect(() => {
        const newProductsDetails = {};
        selectedProducts.forEach((productId) => {
            const product = propsProduct[productId];
            if (product) {
                newProductsDetails[productId] = product;
            }
        });

        // Replace with the current selection snapshot to avoid stale products lingering
        setSelectedProduct((prevSelectedProduct) => {
            if (JSON.stringify(prevSelectedProduct) !== JSON.stringify(newProductsDetails)) {
                return newProductsDetails;
            }
            return prevSelectedProduct;
        });
    }, [selectedProducts, propsProduct]);    

    // useEffect(() => {
    //     const newProductsDetails = {};
    //     selectedProducts.forEach((productId) => {
    //         const product = propsProduct[productId];
    //         if (product) {
    //             newProductsDetails[productId] = product;
    //         }
    //     });
    
    //     setSelectedProduct((prevSelectedProduct) => {
    //         if (JSON.stringify(prevSelectedProduct) !== JSON.stringify(newProductsDetails)) {
    //             return newProductsDetails;
    //         }
    //         return prevSelectedProduct;
    //     });
    // }, [selectedProducts, propsProduct]);

    const isAmountBelowMinimumPayableAmount = () => {
        const result = Object.keys(propsProduct).map((i) => {
            if (Number(propsProduct[i]?.amount) <= 0) {
                return false;
            }
            if (
                Number(propsProduct[i]?.amount) > 0 &&
                Number(propsProduct[i]?.amount) < 1
            ) {
                return true;
            } else {
                return false;
            }
        });

        return result.includes(true);
    };

    const formatAmount = (amount) => {
        // if (amount === 0 || typeof amount !== "number")
        if (Number(amount).toFixed(2) !== "NaN")
            return `${currency?.symbol}${Number(amount).toFixed(2)}`;
        else return `${currency?.symbol}0.00`;
    };

    const setGeneralComments = (id, comment) => {
        let tempvalue = propsProduct[id];
        tempvalue.comment = comment;
        const prodValue = {
            ...propsProduct,
            [`${id}`]: tempvalue,
        };

        setPaymentComments(prevState => ({
            ...prevState,
            [id]: comment,
        }));

        dispatch(setPaymentComment({ id, comment }));

        setPropsProducts({ ...prodValue });
    };

    useEffect(() => {
        if (once) {
            return;
        }

        if (propsProductIds?.length > 0 && !shouldModifyAmount) {
            const amountValue = propsProductIds.reduce((acc, cur) => {
                return Number(acc) + Number(cur?.amount);
            }, 0);
            setPropsAmount(Number(amountValue));
            return;
        }

        if ((productList?.length ?? 0) > 0) {
            const values = {};
            productList.forEach((i) => {
                values[i.product_id] = {
                    amount: i?.amount
                        ? Number(i?.amount).toFixed(2)
                        : Number(tempAmount) ?? 0,
                    comment: "",
                };
            });
            
            setPropsProducts({ ...values });

            selectedProducts.forEach((productId) => {
                const product = propsProduct[productId];
                productsDetails[productId] = product;
            });
            setSelectedProduct({ ...productsDetails });

            setOnce(true);

            // const newProducts = Object.keys(values).map((i) => {
            //     return { item: i };
            // });

            // const newProductAmount = newProducts.reduce((acc, cur) => {
            //     return Number(acc) + Number(values[cur.item]);
            // }, 0);

            let selectedProductIds = [];
            Object.keys(values).forEach((key) => {
                selectedProductIds.push(key);
            });
            
            const newProductAmount = selectedProductIds.reduce((acc, cur) => {
                return acc + (values[cur]?.amount || 0);
            }, 0);

            setPropsAmount(Number(newProductAmount));
        }
    }, [productList, propsProductIds, once, shouldModifyAmount, selectedProducts, setPropsAmount, setPropsProducts, setOnce, tempAmount, setSelectedProduct, productsDetails, propsProduct]);

    useEffect(() => {
        if (Object.keys(propsProduct).length > 0) {
            if (productId && propsProduct[productId]) {
                const updatedProducts = { ...propsProduct };
    
                updatedProducts[productId] = {
                    ...updatedProducts[productId],
                    amount: Number(propsProduct[productId].amount) || tempAmount,
                };

                Object.keys(updatedProducts).forEach((key) => {
                    if (key !== productId) {
                        updatedProducts[key].amount = 0;
                    }
                });
    
                setPropsProducts(updatedProducts);
                setGeneralAmount(Number(updatedProducts[productId].amount) || tempAmount, productId);
            }
        }
    }, [propsProduct, productId, tempAmount, setGeneralAmount, setPropsProducts]);    
    
    const checkForFixedAmountProducts = productList.some(
        (product) => product?.amount !== undefined && product?.amount > 0
    );

    useEffect(() => {
        if (productList) {
            setPropProductList(productList);
        }
    }, [productList, setPropProductList]);

    const [isRedirectModalOpen, setRedirectModalOpen] = useState(false);

    const openRedirectModal = () => setRedirectModalOpen(true);
    const closeRedirectModal = () => setRedirectModalOpen(false);

    return (
        <div
            className={`flex  flex-col gap-3 w-full ${
                isProduct ? "hidden" : ""
            }`}>

            <div className="bg-[#A4A4A4] w-full h-[50px] text-white justify-start px-4 flex justify-between items-center font-bold">
                <div className="flex items-center">
                    <div className="w-[30px] h-[30px] rounded-full border-4 border-[#fff]">
                        {merchantDetails?.imageUrl && (
                            <img
                                src={merchantDetails?.imageUrl}
                                alt=""
                                height="30"
                                width="30"
                                className="rounded-[50%]"
                            />
                        )}
                    </div>
                    &nbsp;&nbsp;
                    <p>
                        {merchantDetails?.ent_type === "RELIGIOUS"
                            ? merchantDetails.reg_name
                            : "Product Amount"}
                    </p>
                </div>

                {merchantDetails?.inc_no === "06994834" && (
                    <button
                        onClick={() => window.location.href = "https://business.xcelapp.com/#/payments/wcis"}
                        className="bg-none text-white font-medium"
                    >
                        Change Branch
                    </button>
                )}
            </div>

            {productList.length === 0 && (
                <div className="h-[90vh] lg:h-[60vh] flex flex-col w-full justify-center items-center">
                    <div>
                        <div className="text-center">
                            <Spin />
                        </div>
                        <p className="font-semibold p-3">
                            Loading...
                        </p>
                    </div>
                </div>
            )}

            {productList.length > 0 && (
                <div>
                    <div className="px-5 py-5 w-full">
                        {checkForFixedAmountProducts && (
                            <div className="flex flex-row w-full justify-between items-center pb-2">
                                <p className="font-bold text-[#031339]">
                                    Tick the box to select a product with fixed amount
                                </p>
                            </div>
                        )}

                        <div className="flex flex-row w-full justify-between items-center">
                            <Text className="font-bold text-[#031339]">
                                {merchantDetails?.ent_type === "RELIGIOUS"
                                    ? "Giving To"
                                    : "Product(s)"}
                            </Text>
                            <Text className="font-bold text-[#031339]">Amount</Text>
                        </div>

                        <div className="flex flex-col w-full justify-between items-center">
                            {productList.map((i) => {
                                const isSelected = selectedProducts.includes(
                                    i.product_id
                                );
                                return (
                                    <ItemAmount
                                        key={i.product_id}
                                        propAmount={
                                            propsProduct?.[i.product_id]?.amount ?? 0
                                        }
                                        onSet={(e) => {
                                            setGeneralAmount(Number(e), i.product_id);
                                        }}
                                        onSetComment={(e) => {
                                            setGeneralComments(i.product_id, e);
                                            // setComment(e);
                                        }}
                                        onCheckboxChange={() =>
                                            handleCheckboxChange(i.product_id, Number(i?.amount))
                                        }
                                        i={i}
                                        isDisabled={
                                            !isUndefined(i?.amount) &&
                                            Number(i?.amount) > 0
                                        }
                                        isSelected={isSelected}
                                        currency={currency}
                                    />
                                );
                            })}
                        </div>

                        <div className="my-8">
                            <button
                                className="bg-[#222121] hover:bg-[#323131] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                                type="button"
                                disabled={
                                    Object.keys(propsProduct)
                                        .map((i) => {
                                            return {
                                                item: i,
                                                value: propsProduct[i]?.amount,
                                            };
                                        })
                                        .filter((i) => i.value > 0).length === 0
                                }
                                onClick={() => {
                                    if (hasProphetProduct && (propsProduct[prophetProduct[0]?.product_id].amount !== 0 && propsProduct[prophetProduct[0]?.product_id].comment.trim() === '')) {
                                        toast.error('Please add a note/comment for Prophet Offering', 'Error');
                                    } else {
                                        setApplePay(false);
                                        if (currency?.code === "GBP") {
                                            if (isAmountBelowMinimumPayableAmount()) {
                                                toast.warning(
                                                    "Minimum payable amount is £1"
                                                );
                                            } else if (amount > 8000 && isGuest && merchantDetails?.inc_no === "06994834") {
                                                setUkMaxAmountMessage(true);
                                            } else {
                                                if (
                                                    merchantDetails?.ent_type ===
                                                    "RELIGIOUS"
                                                ) {
                                                    setShowMessage(true);
                                                } else {
                                                    setShowSystemMessage(true);
                                                }
                                            }
                                        } else {
                                            setIsProduct(false);
                                        }
                                    }
                                }}>
                                Proceed to{" "}
                                {merchantDetails?.ent_type === "RELIGIOUS"
                                    ? "Give"
                                    : "Pay"}{" "}
                                {formatAmount(amount) || 0}
                                {(merchantDetails?.payment_options?.length === 1 
                                    && merchantDetails?.payment_options[0] === 'Pay with Card') ? ' (Credit/Debit Card)' : ''}
                            </button>
                            { currency?.code === "GBP" && (
                                <button
                                    className="mt-3 bg-[#222121] hover:bg-[#323131] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                                    type="button"
                                    disabled={
                                        Object.keys(propsProduct)
                                            .map((i) => {
                                                return {
                                                    item: i,
                                                    value: propsProduct[i]?.amount,
                                                };
                                            })
                                            .filter((i) => i.value > 0).length === 0
                                    }
                                    onClick={() => {
                                        if (hasProphetProduct && (propsProduct[prophetProduct[0]?.product_id].amount !== 0 && propsProduct[prophetProduct[0]?.product_id].comment.trim() === '')) {
                                            toast.error('Please add a note/comment for Prophet Offering', 'Error');
                                        } else {
                                            if (isAmountBelowMinimumPayableAmount()) {
                                                toast.warning(
                                                    "Minimum payable amount is £1"
                                                );
                                            } else if (amount > 8000 && isGuest && merchantDetails?.inc_no === "06994834") {
                                                setUkMaxAmountMessage(true);
                                            } else {
                                                setApplePay(true);
                                                if (
                                                    merchantDetails?.ent_type ===
                                                    "RELIGIOUS"
                                                ) {
                                                    setShowMessage(true);
                                                } else {
                                                    setShowSystemMessage(true);
                                                }
                                            }
                                        }
                                    }}>
                                    <span className="flex justify-center items-center gap-2">
                                        <img
                                            src='./images/apple-icon.svg'
                                            alt='apple-icon'
                                        />
                                        /
                                        <img width={20}
                                            src='./images/gpay2.png'
                                            alt='google-pay-icon'
                                        />
                                        Pay &nbsp;
                                        {formatAmount(amount) || 0}
                                    </span>
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {message}
            {systemMessage}
            {ukMaxAmountMessage}
            <div>
                <button id="redirect-modal" className="hidden" onClick={openRedirectModal}>Open Modal</button>
                <RedirectDialog isOpen={isRedirectModalOpen} onClose={closeRedirectModal}>
                <p className="mt-10 text-center text-lg font-medium">
                        You are about to 
                            {merchantDetails?.ent_type === "RELIGIOUS"
                                ? " Give"
                                : " Pay"}{" "}
                            <strong>{formatAmount(amount) || 0} </strong>
                        via <strong>Apple/Google Pay</strong>
                    </p>

                    <div className="p-4 mt-6 flex justify-end gap-4 border-t">
                        <button className="text-black" onClick={closeRedirectModal}>Cancel</button>
                        <a href={redirectUrl} target="_blank" rel="noreferrer" onClick={closeRedirectModal}
                            className="hover:text-white text-md font-medium border border-black rounded-lg px-6 py-3 bg-black text-white">
                            Proceed
                        </a>
                    </div>
                </RedirectDialog>
            </div>
        </div>
    );
}

export default HandleAmount;